import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1025b564")
const _hoisted_1 = { class: "farming-detail-container" }
const _hoisted_2 = { class: "title-wrap" }
const _hoisted_3 = { class: "item-title" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "product-item" }
const _hoisted_6 = { class: "right" }
const _hoisted_7 = { class: "farming-info" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "person" }
const _hoisted_10 = {
  key: 0,
  class: "video"
}
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "info" }
const _hoisted_13 = {
  key: 1,
  class: "learning-title"
}
const _hoisted_14 = { class: "farming-info" }
const _hoisted_15 = { class: "title" }
const _hoisted_16 = { class: "person" }
const _hoisted_17 = { class: "pop-btn-wrap" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("svg", {
  class: "icons-font",
  style: {"width":"1.5rem","height":"1.5rem"},
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#icon-z" })
], -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 记录成果 ")
const _hoisted_20 = [
  _hoisted_18,
  _hoisted_19
]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_hori_slide = _resolveComponent("hori-slide")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, "操作开始时间：" + _toDisplayString(_ctx.farmingDetailData.optionTime), 1),
        _createElementVNode("div", null, _toDisplayString(_ctx.farmingDetailData.status == 0
              ? "未操作"
              : _ctx.farmingDetailData.status == 1
              ? "已完成"
              : _ctx.farmingDetailData.status == 2
              ? "已忽略"
              : ""), 1),
        (_ctx.farmingDetailData.outTime > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, " 逾期" + _toDisplayString(_ctx.farmingDetailData.outTime) + "天 ", 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_van_image, {
          class: "left",
          src: 
            _ctx.farmingDetailData.typeImg
              ? _ctx.farmingDetailData.typeImg + '?imageView2/1/w/100/h/100/rotate/0'
              : ''
          ,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.preview(_ctx.farmingDetailData.typeImg || undefined)))
        }, null, 8, ["src"]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", null, _toDisplayString(_ctx.farmingDetailData.typeName), 1),
          _createElementVNode("div", null, [
            _createElementVNode("span", null, "地块编码：" + _toDisplayString(_ctx.farmingDetailData.areaCode), 1),
            _createElementVNode("span", null, "种植面积：" + _toDisplayString(_ctx.farmingDetailData.areaArea) + "亩", 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.farmingDetailData.plantFarmingName), 1),
      _createElementVNode("div", _hoisted_9, " 预计人工：" + _toDisplayString(_ctx.farmingDetailData.plantFarmingArtificial) + "人工/亩 ", 1),
      (_ctx.farmingDetailData.plantFarmingVideo)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("video", {
              controls: "controls",
              src: _ctx.farmingDetailData.plantFarmingVideo
            }, " 您的浏览器不支持查看视频 ", 8, _hoisted_11)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.farmingDetailData.plantFarmingInfo), 1),
      (
          _ctx.farmingDetailData.plantFarmingImgList &&
          _ctx.farmingDetailData.plantFarmingImgList.length > 0
        )
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, " 操作教学 "))
        : _createCommentVNode("", true),
      _createVNode(_component_hori_slide, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.farmingDetailData.plantFarmingImgList, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_image, {
              key: index,
              src: item,
              radius: "5px",
              onClick: ($event: any) => (_ctx.preview(item)),
              class: "img-item"
            }, null, 8, ["src", "onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, "物候期：" + _toDisplayString(_ctx.farmingDetailData.phaseName || "无"), 1),
      _createElementVNode("div", _hoisted_16, "说明：" + _toDisplayString(_ctx.farmingDetailData.phaseInfo || "无"), 1),
      _createVNode(_component_hori_slide, null, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.farmingDetailData.phaseImgList, (item, index) => {
            return (_openBlock(), _createBlock(_component_van_image, {
              key: index,
              src: item,
              radius: "5px",
              onClick: ($event: any) => (_ctx.preview(_ctx.farmingDetailData.phaseImgList,index)),
              class: "img-item"
            }, null, 8, ["src", "onClick"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createElementVNode("button", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onRecord && _ctx.onRecord(...args)))
      }, _hoisted_20)
    ])
  ]))
}